const sectionCardCompareB1Css = `
[data-type='section-card-compare-b1'] .wrapper-container {
  color: var(--text-color, #000000);
}

[data-type='section-card-compare-b1'] .wrapper-container[data-top-padding='true'] {
  padding-top: 40px;
}

[data-type='section-card-compare-b1'] .wrapper-container[data-bottom-padding='true'] {
  padding-bottom: 40px;
}

[data-type='section-card-compare-b1'] .wrapper-content {
  max-width: 840px;
}

[data-type='section-card-compare-b1'] .wrapper-content .header-section {
  margin-bottom: 22px;
}

[data-type='section-card-compare-b1'] .wrapper-content .header-section h1,
[data-type='section-card-compare-b1'] .wrapper-content .header-section h2,
[data-type='section-card-compare-b1'] .wrapper-content .header-section h3,
[data-type='section-card-compare-b1'] .wrapper-content .header-section h4 {
  font-size: 24px;
  line-height: normal;
  margin: 0 0 16px 0 !important;
}

[data-type='section-card-compare-b1'] .wrap-compare {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 40px;
}

[data-type='section-card-compare-b1'] .wrap-compare .item-block {
  position: relative;
  width: calc((100% - 12px) / 2);
}

[data-type='section-card-compare-b1'] .wrap-compare .item-block .wrap-img {
  width: 100%;
  aspect-ratio: 394 / 480;
  position: relative;
  overflow: hidden;
  border-radius: 12px;
}

[data-type='section-card-compare-b1'] .wrap-compare .item-block .wrap-img img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

[data-type='section-card-compare-b1'] .wrap-compare .item-block .text-label {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 50%);
  max-width: 100%;
  text-align: center;
  font-size: 24px;
  font-weight: bold !important;
  padding: 1px 20px;
  border-radius: 100px;
}

[data-type='section-card-compare-b1'] .summary-section {
  display: none;
  border-radius: 10px;
  padding: 10px;
  margin-bottom: 20px;
}

[data-type='section-card-compare-b1'] .summary-section[data-show-summary='true'] {
  display: block;
}

[data-type='section-card-compare-b1'] .wrap-button {
  display: none;
}

[data-type='section-card-compare-b1'] .wrap-button[data-show-btn='true'] {
  display: block;
}

[data-type='section-card-compare-b1'] .wrap-button a {
  display: block;
  max-width: 500px;
  margin: 0 auto !important;
  text-align: center;
  padding: 16px 32px;
  border-radius: 12px;
  text-decoration: none;
  font-weight: bold !important;
  margin-bottom: 10px;
}

[data-type='section-card-compare-b1'] .wrap-button .sub-btn {
  font-size: 14px;
  text-align: center;
  margin-top: 10px;
}

@container (max-width: 768px) {
  [data-type='section-card-compare-b1'] .wrapper-container[data-top-padding='true'] {
    padding-top: 16px;
  }

  [data-type='section-card-compare-b1'] .wrapper-container[data-bottom-padding='true'] {
    padding-bottom: 16px;
  }

  [data-type='section-card-compare-b1'] .wrapper-content .header-section h1,
  [data-type='section-card-compare-b1'] .wrapper-content .header-section h2,
  [data-type='section-card-compare-b1'] .wrapper-content .header-section h3,
  [data-type='section-card-compare-b1'] .wrapper-content .header-section h4 {
    font-size: 20px;
    line-height: 24px;
  }
}
`;
export default sectionCardCompareB1Css;
